import React from "react";

import { Card, Icon } from "components";

type LinedCardColor = "grey" | "red" | "blue" | "green";

interface LinedCardProps {
  dataTestId?: string;
  className?: string;
  color?: LinedCardColor;
  title?: string;
  titleIconName?: string;
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  secondaries?: React.ReactNode[];
  tertiary?: React.ReactNode;
  warningHeader?: string;
  onClick?: () => void;
}

// This component can also be used with multiple secondaries instead of one secondary
export const LinedCard = ({
  className,
  color,
  primary,
  secondary,
  secondaries,
  tertiary,
  title,
  titleIconName,
  dataTestId,
  onClick,
  warningHeader,
}: LinedCardProps) => (
  <Card onClick={onClick} className={`lined-card ${color} ${!secondary ? " small" : ""} ${className}`} dataTestId={dataTestId} mixpanelText="lined-card">
    {warningHeader && <div className="warning-header">{warningHeader}</div>}

    {title && (
      <div className={`title ${color}`}>
        <Icon iconName={titleIconName || ""} />
        <h5>{title}</h5>
      </div>
    )}

    <div className="primary">{primary}</div>
    {secondary && <div className="secondary">{secondary}</div>}

    {secondaries &&
      secondaries.map((secondary, i) => (
        <div className="secondary" key={i}>
          {secondary}
        </div>
      ))}

    {tertiary && <div className="secondary">{tertiary}</div>}
  </Card>
);

export default LinedCard;
